import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { KPI } from '../../../@core/api';
import { ChartFiltersService } from '../../../@core/utils';

import { FormsModule } from '@angular/forms';
import { NbRadioModule } from '@nebular/theme';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-budget-or-ratio-carbon-filter',
    templateUrl: './budget-or-ratio-carbon-filter.component.html',
    styleUrls: ['./budget-or-ratio-carbon-filter.component.scss'],
    standalone: true,
    imports: [NbRadioModule, FormsModule, TranslateModule, NgClass]
})
export class BudgetOrRatioCarbonFilterComponent implements OnInit, OnDestroy {
  
  @Input() public justifyContentRight: boolean = false;

  public budgetOrRatioCarbonFilterOptions = [
    {
      value: KPI.BudgetOrRatioCarbonFilter.TRAJECTORY_ONLY,
      label: this.translate.instant('Trajectory only'),
    },
    {
      value: KPI.BudgetOrRatioCarbonFilter.CAPEX_AMOUNT,
      label: this.translate.instant('With CAPEX amount'),
    },
  ];

  public budgetOrRatioCarbonFilter: number;

  private subscriptions: Subscription[] = [];

  constructor(
    private chartFiltersService: ChartFiltersService,
    private translate: TranslateService,
  ) {
  }

  public ngOnInit(): void {
    this.subscriptions.push(
      this.chartFiltersService.filter$('budgetOrRatioCarbon').pipe(
        first()
      ).subscribe((budgetOrRatioCarbonFilter) =>
        this.budgetOrRatioCarbonFilter = <number>budgetOrRatioCarbonFilter,
      ),
    );
  }

  public budgetOrRatioFilterChanged(): void {
    setTimeout(() => {
      this.chartFiltersService.setFilter('budgetOrRatioCarbon', this.budgetOrRatioCarbonFilter);
    }, 50);
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

}
